export const tabs = {
  LISTINGS: 'listings',
  BUILDINGS: 'buildings',
}

